import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import CtaStyle2 from '../Cta/CtaStyle2';
import AboutStyle6 from '../About/AboutStyle6';
import CardStyle3 from '../Card/CardStyle3';
import { pageTitle } from '../../helpers/PageTitle';

export default function InstallationServicesPage() {
  pageTitle('Installation Services - Soketry Solutions');

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Expert Installation Services"
        subTitle="Ensuring Optimal Performance of Your Renewable Energy Systems"
        shape="shape_3"
      />
      <Spacing lg="75" md="60" />
      <div className="cs_service_info">
        <div className="container">
          <div className="row align-items-center cs_gap_y_40">
            <div className="col-lg-6">
              <div
                className="cs_service_info_thumb cs_bg_filed"
                style={{
                  backgroundImage: 'url("/images/installation/installation-1.jpg")',
                }}
              />
            </div>
            <div className="col-lg-6">
              <div className="row cs_gap_y_40">
                <div className="col-sm-6">
                  <CardStyle3
                    number="01"
                    title="Site Preparation"
                    subTitle="Proper site preparation is crucial for the successful installation of renewable energy systems. Our team handles everything from initial assessments to preparing the installation site to ensure a smooth setup process."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="02"
                    title="System Installation"
                    subTitle="Our certified technicians are experts in installing a variety of renewable energy systems, including solar panels, wind turbines, and more, with precision and adherence to the highest safety standards."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="03"
                    title="Testing and Commissioning"
                    subTitle="After installation, we conduct thorough testing and commissioning to ensure that the systems operate efficiently and meet all expected performance metrics."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="04"
                    title="Follow-Up Services"
                    subTitle="We provide follow-up services to monitor the systems and perform necessary adjustments or repairs to maintain optimal performance over time."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
      <AboutStyle6
        thumbnailSrc="/images/installation/installation-2.jpg"
        title="Comprehensive Installation Services"
        subTitle="Our installation services are designed to ensure your renewable energy solutions are set up for success from day one. With attention to detail and a focus on maximizing system efficiency, our team is committed to delivering exceptional results."
        featureList={[
          'Initial Site Assessment',
          'Professional Installation',
          'Rigorous Testing Procedures',
          'Ongoing System Maintenance'
        ]}
        btnText="Explore Our Projects"
        btnUrl="/portfolio"
      />
      <Spacing lg="150" md="80" />
      <CtaStyle2
        title="Ready to Get Started with Renewable Energy?"
        btnText="Contact Us"
        btnUrl="/contact"
      />
      <Spacing lg="150" md="80" />
    </>
  );
}
